import React from 'react';
import {Box, Flex, HStack, Text} from '@tempo/core';
import type {TdProps} from '@components/Table/core/Td';
import Td from '@components/Table/core/Td';
import type {ManagerClaim} from '@deezer/next/services/api/Starmania/requests/claim/types';
import Thumbnail from '@components/Thumbnail';
import {ContentType} from '@deezer/next/services/types/contentType';
import {ChevronBottomIcon, ChevronTopIcon} from '@tempo/icons';
import ArtistClaimDetails from '@deezer/next/features/ClaimAccess/components/ClaimTable/ArtistClaimDetails';

type ManagerClaimCellProps = {
	claim: ManagerClaim;
	onToggle: () => void;
	isCollapsed: boolean;
} & TdProps;

const ManagerClaimCell = ({
	claim,
	onToggle,
	isCollapsed,
	...rest
}: ManagerClaimCellProps) => {
	if (claim.artists.length === 1) {
		return (
			<Td whiteSpace="pre-wrap" {...rest}>
				<ArtistClaimDetails
					artist={{...claim.artists[0], id: claim.artists[0].artistId}}
				/>
			</Td>
		);
	}

	return (
		<Td whiteSpace="pre-wrap" {...rest}>
			<HStack spacing="spacing.s" onClick={onToggle} cursor="pointer">
				{isCollapsed ? <ChevronBottomIcon /> : <ChevronTopIcon />}
				<Flex direction="row">
					{claim.artists.slice(0, 3).map((artist, index) => (
						<Box
							key={artist.artistId}
							marginStart={index > 0 ? '-8px' : 0}
							zIndex={claim.artists.slice(0, 3).length - index}
						>
							<Thumbnail
								coverLink={false}
								type={ContentType.Artist}
								height={'24px'}
								width={'24px'}
								picture={artist.imageHash}
								rounded={true}
							/>
						</Box>
					))}
				</Flex>
				<Text noOfLines={1} fontWeight="semibold" wordBreak="break-all">
					{claim.artists.map(a => a.name).join(', ')}
				</Text>
			</HStack>
		</Td>
	);
};

export default ManagerClaimCell;
